import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { Field, Form, Formik } from "formik";
import * as yup from "yup";
import LoadingButton from "@mui/lab/LoadingButton";
import TextField from "@mui/material/TextField";

export interface VoidNoticeDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (values: { reason: string; voidedAt: Date }) => void | Promise<void>;
  entityLabel: string;
  isSubmitting?: boolean;
}

interface FormValues {
  reason: string;
}

const validationSchema = yup.object({
  reason: yup.string().required("Reason is required"),
});

export const VoidNoticeDialog: React.FC<VoidNoticeDialogProps> = ({
  open,
  onClose,
  onSubmit,
  entityLabel,
  isSubmitting = false,
}) => {
  const initialValues: FormValues = {
    reason: "",
  };

  const handleClose = (formik: { resetForm: () => void }) => {
    formik.resetForm();
    onClose();
  };

  const handleSubmit = (values: FormValues) => {
    return onSubmit({ reason: values.reason, voidedAt: new Date() });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Void {entityLabel}</DialogTitle>
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
        {(formik) => (
          <Form>
            <DialogContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    as={TextField}
                    name="reason"
                    label="Reason"
                    fullWidth
                    error={formik.touched.reason && Boolean(formik.errors.reason)}
                    helperText={formik.touched.reason && formik.errors.reason}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button fullWidth onClick={() => handleClose(formik)}>
                Cancel
              </Button>
              <LoadingButton
                fullWidth
                type="submit"
                variant="contained"
                color="error"
                loading={isSubmitting || formik.isSubmitting}
                disabled={isSubmitting || formik.isSubmitting || !formik.dirty || !formik.isValid}
              >
                Void {entityLabel}
              </LoadingButton>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default VoidNoticeDialog;
